import { Box } from "@chakra-ui/react";
import { colors, ColorIcon, Spacing } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { CheckMarkIcon, ChevronRightIcon } from "./MubinsoUI";
import { FAMILY_BRANCH_OPTIONS, FAMILY_LANDING, FamilyBranchKey } from "./mubinsoConstants";

// M5 가족장 퍼널(가족장 소재 n_ad 또는 ?template=family) 전용 화면. 명세: wiki/plans/mubinso-family-funnel.md

// ---------------------------------------------------------------------------
// 첫 화면 - 제목 · 설명 아래 바로 분기 카드 2개를 둔다(소개 카드 · 고이 박스 · CTA 버튼 없음).
// 카드를 누르면 바로 이동한다(다음 버튼, 진행 막대 없음).
// 360 폭에서 "달라/져요" 처럼 단어 중간에서 끊기지 않게 문구는 단어 단위로만 줄을 바꾼다(keep-all)
// ---------------------------------------------------------------------------
export function MubinsoFamilyIntroScreen({
  value,
  onPick,
}: {
  value: FamilyBranchKey | null;
  onPick: (key: FamilyBranchKey) => void;
}) {
  return (
    // 가운데 정렬은 margin 대신 감싼 Box 의 flex 로 한다(CLAUDE.md margin 직접 사용 금지)
    <Box width="100%" display="flex" justifyContent="center">
      <BaseStack width="100%" maxW="480px" minH="100dvh" px={24}>
        <Spacing gap={56} />
        <Box width="100%" className="head2_b" color={colors.black}>
          <span style={{ color: colors.orange650 }}>가족장</span>을
          <br />
          알아보고 계신가요?
        </Box>
        <Spacing gap={12} />
        <Box
          width="100%"
          whiteSpace="pre-line"
          wordBreak="keep-all"
          className="body_16_r"
          color={colors.gray600}
        >
          {FAMILY_LANDING.sub}
        </Box>

        <Spacing gap={32} />
        <BaseStack width="100%" spacing={12}>
          {FAMILY_BRANCH_OPTIONS.map((option) => {
            const isSelected = value === option.key;
            return (
              <Box
                key={option.key}
                as="button"
                type="button"
                aria-pressed={isSelected}
                width="100%"
                display="flex"
                alignItems="center"
                // 360 폭에서 "빈소가 없어 조문객을 받지 않아요"(210px)가 한 줄에 들어가도록 좌우 패딩 12px, 간격 8px
                gap="8px"
                textAlign="left"
                cursor="pointer"
                borderRadius="6px"
                // 선택 시 테두리가 2px 로 두꺼워지는 만큼 패딩을 1px 줄여 카드 크기를 유지한다
                border={
                  isSelected ? `2px solid ${colors.orange650}` : `1px solid ${colors.gray200}`
                }
                padding={isSelected ? "19px 11px" : "20px 12px"}
                bg={isSelected ? colors.orange50 : colors.white}
                _hover={{ bg: isSelected ? colors.orange50 : colors.gray50 }}
                onClick={() => onPick(option.key)}
              >
                <ColorIcon name={option.icon} size={40} />
                <BaseStack flex={1} minW={0} spacing={6}>
                  <Box className="subtitle_16_sb" color={colors.gray900}>
                    {option.label}
                  </Box>
                  <BaseStack width="100%" spacing={4}>
                    {option.lines.map((line) => (
                      <BaseStack
                        key={line.text}
                        direction="horizontal"
                        spacing={6}
                        alignItems="center"
                      >
                        <Box
                          flex="none"
                          width="18px"
                          height="18px"
                          borderRadius="50%"
                          bg={colors.orange200}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          {/* 굵은 선형 체크 12px(그려지는 폭 약 8px). 면형 icon-check-mono 11px 은
                            실제 폭이 5px 라 작고 흐리다(E4 체크 카드와 같은 모양) */}
                          <CheckMarkIcon color={colors.orange650} size={12} />
                        </Box>
                        <Box wordBreak="keep-all" className="body_14_r" color={colors.gray700}>
                          {line.text}
                        </Box>
                      </BaseStack>
                    ))}
                  </BaseStack>
                </BaseStack>
                <Box flex="none" color={colors.gray400}>
                  <ChevronRightIcon />
                </Box>
              </Box>
            );
          })}
        </BaseStack>
        <Spacing gap={40} />
      </BaseStack>
    </Box>
  );
}
